import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import { store } from './state/store';
import App from './App';
import { loadReCaptchaScript } from './utils/recaptcha';

// Load ReCaptcha script before rendering the app
loadReCaptchaScript();

// Initialize the app after ReCaptcha script is loaded
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	// <React.StrictMode>
	<BrowserRouter>
		<Provider store={store}>
			<App />
		</Provider>
	</BrowserRouter>
	// </React.StrictMode>
);
